// fetch wrapper that feeds the connectivity monitor: a TypeError (network
// failure) marks us offline, any HTTP response marks us online. Used by the
// data layer so offline detection does not rely on navigator.onLine alone.

let monitor = null;
export function setConnectivityMonitor(m) { monitor = m; }
export function getConnectivityMonitor() { return monitor; }

export async function apiFetch(input, init) {
  try {
    const res = await fetch(input, init);
    monitor?.reportSuccess();
    return res;
  } catch (err) {
    if (err?.name !== 'AbortError') monitor?.reportFailure();
    throw err;
  }
}
